import { defineCustomElement } from "vue";

import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";

import urqlPlugin, { Client as GqlClient, fetchExchange, cacheExchange } from "@urql/vue";
import { retryExchange } from "@urql/exchange-retry";

import "./style/main.less";
import {} from "./lib/patches.ts";

import NavbarSuspend from "./components/NavbarSuspend.vue";
import FooterSuspend from "./components/FooterSuspend.vue";
import SidebarSuspend from "./components/SidebarSuspend.vue";
import Prose from "./components/Prose.vue";
import FigureSuspend from "./components/FigureSuspend.vue";
import ImageSuspend from "./components/ImageSuspend.vue";
import FormSuspend from "./components/FormSuspend.vue";
import { Session } from "./lib/craft.ts";
import LoginForm from "./components/LoginForm.vue";
import ResetPasswordForm from "./components/ResetPasswordForm.vue";
import ChangePasswordForm from "./components/ChangePasswordForm.vue";
import CentreDirectorySuspend from "./components/CentreDirectorySuspend.vue";
import SingleLocationMapSuspend from "./components/SingleLocationMapSuspend.vue";
import CentreDirectoryEntrySuspend from "./components/CentreDirectoryEntrySuspend.vue";
import CentreDirectoryAuthorControls from "./components/CentreDirectoryAuthorControls.vue";
import EditAccountFormSuspend from "./components/EditAccountFormSuspend.vue";


const gql = new GqlClient({
  url: "/actions/adco/graphql/api",
  fetchOptions: {
    cache: "default",
  },
  // request caching doesn't work with post requests
  preferGetMethod: "force",
  exchanges: [
    cacheExchange,
    retryExchange({
      initialDelayMs: 1500,
      maxDelayMs: 15000,
      maxNumberAttempts: 5,
      retryIf: error => {
        return error.networkError !== undefined;
      },
    }),
    fetchExchange
  ],
  requestPolicy: "cache-first",
});

const session = new Session();
if (window.craft != null) { window.craft.session = session; }


const components: { [key: string]: any } = {
  NavbarSuspend, FooterSuspend, SidebarSuspend,
  Prose,
  FigureSuspend, ImageSuspend, FormSuspend,
  CentreDirectorySuspend,
  CentreDirectoryAuthorControls, CentreDirectoryEntrySuspend,
  SingleLocationMapSuspend,
  LoginForm, ResetPasswordForm, ChangePasswordForm, EditAccountFormSuspend,
};

for (const name in components) {
  // custom element name must contain a hypen
  customElements.define(`v-${name.toLowerCase()}`, defineCustomElement(
    components[name],
    {
      shadowRoot: false,
      configureApp(app) {
        app.config.globalProperties.$gql = gql;
        app.provide("gql", gql);
        app.config.globalProperties.$session = session;
        app.provide("session", session);

        app.use(urqlPlugin, gql);

        app.use(PrimeVue, {
          cssLayer: true,
          theme: {
            preset: Aura,
            options: {
              darkModeSelector: ".p-dark",
            }
          }
        });
      },
    }
  ));
}
